import React, { FC } from "react";

import { renderToStaticMarkup } from "react-dom/server";

/**
 * Encodes a React SVG component into a data URI string.
 *
 * @param Component - The React functional component representing the SVG.
 *                    This component should return an SVG element when rendered.
 * @param props - Optional props to pass to the SVG component. Defaults to an empty object.
 * @returns A data URI string representing the encoded SVG.
 *
 * @example
 * // Define a simple SVG component
 * const SampleSVG: React.FC = () => (
 *   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100" height="100">
 *     <circle cx="50" cy="50" r="40" stroke="black" strokeWidth="3" fill="red" />
 *   </svg>
 * );
 *
 * // Convert the SVG to a data URI
 * const svgDataURI = encodeSVGComponentToDataURI(SampleSVG);
 * console.log(svgDataURI);
 *
 * // Usage in JSX
 * <img src={svgDataURI} alt="Sample SVG" />;
 */
export const encodeSVGComponentToDataURI = (Component: FC<unknown>, props = {}): string => {
  const svgString = renderToStaticMarkup(<Component {...props} />);
  return `data:image/svg+xml,${encodeURIComponent(svgString)}`;
};
